import type { Domain } from "@superblocksteam/shared";

import { defineAction } from "store/utils/action";

import slice from "./slice";

export const setOrganizationState = defineAction<{
  name?: string;
  domains?: Domain[];
}>(slice.name, "setOrganizationState");
